import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { UserAccessService } from '@core/services/user-access/user-access.service';
import { ApiSendRequestService } from '@services/api/api.send.request.service';
import { ApiService } from '@services/api/api.service';
import { DataService } from '@services/api/data.service';
import { ConfigService } from '@services/config/config.service';
import { StorageService } from '@services/storage/storage.service';
// TODO: @wdpr/ra-angular-error-handler is not Ivy-compatible. Using Angular's default ErrorHandler.
// TODO: @wdpr/ra-angular-logger is not Ivy-compatible. Using local LoggerService stub.

import { AccessDeniedModule } from '../features/access-denied/access-denied.module';
import { AccessErrorModule } from '../features/access-error/access-error.module';
import { AdminModule } from '../features/admin/admin.module';
import { LoginModule } from '../features/login/login.module';
import { interceptorProviders } from './interceptors/interceptors';

@NgModule({

  imports: [
    AccessDeniedModule,
    AccessErrorModule,
    AdminModule,
    HttpClientModule,
    LoginModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: 'LOGASAURUS_URL',
      useValue: '/api/error'
    },
    ApiService,
    DataService,
    ApiSendRequestService,
    ConfigService,
    StorageService,
    UserAccessService,
    interceptorProviders
  ]
})

export class CoreModule { }
